module.exports = __webpack_public_path__ + "img/TYS-4.df4a28d4.png";